import React, { createContext, useContext, useState } from 'react';

// Contexto para gerenciar dados compartilhados entre componentes
const DataContext = createContext();

// Hook personalizado para usar o contexto de dados
export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData deve ser usado dentro de um DataProvider');
  }
  return context;
};

export const DataProvider = ({ children }) => {
  // Estado para armazenar os dados de cada etapa
  const [calculatorData, setCalculatorData] = useState(null);
  const [scenariosData, setScenariosData] = useState(null);
  const [milestonesData, setMilestonesData] = useState(null);
  const [retirementData, setRetirementData] = useState(null);

  // Função para salvar dados da calculadora
  const saveCalculatorData = (data) => {
    setCalculatorData(data);
  };

  // Função para salvar dados dos cenários
  const saveScenariosData = (data) => {
    setScenariosData(data);
  };

  // Função para salvar dados dos marcos
  const saveMilestonesData = (data) => {
    setMilestonesData(data);
  };

  // Função para salvar dados da aposentadoria
  const saveRetirementData = (data) => {
    setRetirementData(data);
  };

  // Função para obter todos os dados
  const getAllData = () => {
    return {
      calculatorData,
      scenariosData,
      milestonesData,
      retirementData
    };
  };

  // Função para limpar todos os dados
  const clearAllData = () => {
    setCalculatorData(null);
    setScenariosData(null);
    setMilestonesData(null);
    setRetirementData(null);
  };

  // Verificar se há dados disponíveis para exportação
  const hasExportableData = () => {
    return (
      calculatorData !== null ||
      scenariosData !== null ||
      milestonesData !== null ||
      retirementData !== null
    );
  };

  // Valor do contexto
  const value = {
    calculatorData,
    scenariosData,
    milestonesData,
    retirementData,
    saveCalculatorData,
    saveScenariosData,
    saveMilestonesData,
    saveRetirementData,
    getAllData,
    clearAllData,
    hasExportableData
  };

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};

export default DataContext;
